import WhomBlock from "./WhomBlock.vue"

export default function install(Vue) {
  Vue.component(WhomBlock.name, WhomBlock)
}
